import { render, staticRenderFns } from "./deletemodal.vue?vue&type=template&id=212cd2b2&"
import script from "./deletemodal.vue?vue&type=script&lang=js&"
export * from "./deletemodal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports